import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { initTheme } from "./hooks/useTheme";
import "./globals.css";
import "./forms.css";

// F-071: restore the persisted light/dark theme before render, independent of
// any component — routes outside <AppShell/> never mount ThemeToggle.
initTheme();

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
